import PosthogService from '~/services/posthog/PosthogService';

export interface IPermInterviewCancellationReasonSubmittedPayload {
  officeId: string;
  onsiteInterviewId: string;
  postingId: string;
  reason: string;
  othersReason: string;
}

/**
 * Fires when an office submits a cancellation reason for an onsite interview
 * Event: office:perm:interview_cancellation_reason_submitted
 */
export function firePermInterviewCancellationReasonSubmitted(
  payload: IPermInterviewCancellationReasonSubmittedPayload,
): void {
  PosthogService.getInstance().track(
    'office:perm:interview_cancellation_reason_submitted',
    {
      officeId: payload.officeId,
      onsiteInterviewId: payload.onsiteInterviewId,
      postingId: payload.postingId,
      reason: payload.reason,
      othersReason: payload.othersReason,
    },
  );
}
